import React, { useState } from 'react';
import './Tools.css';

const Tools = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = ['All', 'Frontend & Mobile', 'Backend & Cloud', 'Creative & Media', 'DevOps & AI'];

  const toolsData = [
    { name: 'React', category: 'Frontend & Mobile', logo: '/tools/react-native.png' },
    { name: 'React Native', category: 'Frontend & Mobile', logo: '/tools/react-native.png' },
    { name: 'Flutter', category: 'Frontend & Mobile', logo: '/tools/flutter.png' },
    { name: 'Android Studio', category: 'Frontend & Mobile', logo: '/tools/android-studio.png' },
    { name: 'Expo', category: 'Frontend & Mobile', logo: '/tools/expo.png' },

    { name: 'Node.js', category: 'Backend & Cloud', logo: '/tools/nodejs.jpg' },
    { name: 'Express', category: 'Backend & Cloud', logo: '/tools/express.png' },
    { name: 'MongoDB', category: 'Backend & Cloud', logo: '/tools/mongodb.png' },
    { name: 'PostgreSQL', category: 'Backend & Cloud', logo: '/tools/postgreesql.jpg' },
    { name: 'AWS Cloud', category: 'Backend & Cloud', logo: '/tools/aws.png' },
    { name: 'Vercel', category: 'Backend & Cloud', logo: '/tools/vercel.png' },
    { name: 'Netlify', category: 'Backend & Cloud', logo: '/tools/netlify.jpg' },

    { name: 'Figma', category: 'Creative & Media', logo: '/tools/figma.png' },
    { name: 'Photoshop', category: 'Creative & Media', logo: '/tools/photoshop.png' },
    { name: 'Illustrator', category: 'Creative & Media', logo: '/tools/illustrator.png' },
    { name: 'Premiere Pro', category: 'Creative & Media', logo: '/tools/premiere-pro.png' },
    { name: 'After Effects', category: 'Creative & Media', logo: '/tools/after-effects.png' },
    { name: 'DaVinci Resolve', category: 'Creative & Media', logo: '/tools/davinci-resolve.jpg' },
    { name: 'Canva Pro', category: 'Creative & Media', logo: '/tools/canva.jpg' },

    { name: 'Cursor AI', category: 'DevOps & AI', logo: '/tools/cursor.jpg' },
    { name: 'GitHub Actions', category: 'DevOps & AI', logo: '/tools/git.png' },
    { name: 'Jira Enterprise', category: 'DevOps & AI', logo: '/tools/jira.png' },
    { name: 'WhatsApp Business API', category: 'DevOps & AI', logo: '/tools/whatsapp.png' },
  ];

  const filteredTools = activeCategory === 'All'
    ? toolsData
    : toolsData.filter(t => t.category === activeCategory);

  return (
    <section id="tools" className="tools">
      <div className="tools-container">
        <div className="section-header">
          <div className="section-badge">
            <span>Our Toolkit</span>
          </div>
          <h2 className="section-title">Tools & Frameworks We Rely On</h2>
          <p className="section-subtitle">
            We use modern, battle-tested technologies to ensure your applications are fast, secure, and easy to maintain.
          </p>
        </div>

        {/* Tech Stack Categories */}
        <div className="tools-filter-tabs">
          {categories.map((cat, idx) => (
            <button
              key={idx}
              className={`tools-tab-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Tools Grid */}
        <div className="corporate-tools-grid">
          {filteredTools.map((tool, index) => (
            <div key={index} className="corporate-tool-item">
              <div className="tool-card-glow"></div>
              <div className="tool-icon-box">
                <img
                  src={tool.logo}
                  alt={tool.name}
                  className="tool-brand-logo"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    if (e.target.nextSibling) {
                      e.target.nextSibling.style.display = 'flex';
                    }
                  }}
                />
                <div className="tool-logo-monogram" style={{ display: 'none' }}>
                  {tool.name.charAt(0)}
                </div>
              </div>
              <span className="tool-card-name">{tool.name}</span>
              <span className="tool-card-category">{tool.category}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tools;

